<div class="h-[90vh] w-[50vw]">
  <app-modal-header>
    <div class="flex items-center">
      <p translate class="text-xl font-semibold text-theme-900">trilhas.estudio.curso.lista-produtos</p>
    </div>
  </app-modal-header>
  <div app-modal-content class="h-[75vh] w-full rounded-xl bg-base-status-info-50 p-5 shadow-inner">
    <p class="p-2 text-lg font-semibold text-theme-900" translate>trilhas.estudio.curso.seleciona-produto</p>
    <div class="mb-5 mt-2 flex items-center justify-start">
      @if (!anySelected()) {
        <button
          type="button"
          (click)="selectAll()"
          app-icon-button
          translate
          class="group border border-theme-800 text-theme-800 shadow-md hover:bg-theme-800 hover:text-theme-contrast"
          translate
        >
          eclass.marcar-tudo
        </button>
      }
      @if (anySelected()) {
        <button
          type="button"
          (click)="deselectAll()"
          app-icon-button
          translate
          class="group border border-base-status-danger text-base-status-danger shadow-md hover:bg-base-status-danger hover:text-theme-contrast"
        >
          gestor-avaliacoes.desmarcar-tudo
        </button>
      }
    </div>
    <div class="h-[65vh] w-full overflow-y-auto p-2">
      @for (product of products; track product.id; let i = $index) {
        <div class="my-5 flex h-14 w-full items-center justify-start rounded-md p-3 shadow-inner hover:bg-[#fcfcfd]">
          <input app-checkbox [id]="i" class="text-theme-900" type="checkbox" [(ngModel)]="product.checked" />
          <label [for]="i" class="ml-4 cursor-pointer text-md text-theme-900"
            >{{ product.name }} ({{ product.prefix }})</label
          >
        </div>
      }
    </div>
    <div class="flex justify-end gap-2 p-4">
      <button
        (click)="onClose()"
        type="button"
        app-button
        translate
        class="group mr-4 border border-danger text-danger shadow-md hover:bg-danger hover:text-theme-contrast"
      >
        geral.cancelar
      </button>
      <button
        (click)="onSave()"
        type="button"
        app-button
        translate
        class="group border border-theme-800 px-5 text-theme-800 shadow-md hover:bg-theme-800 hover:text-theme-contrast"
      >
        eclass.enviar
      </button>
    </div>
  </div>
</div>
